import { render, staticRenderFns } from "./instagramOverview.vue?vue&type=template&id=a9601d9e&scoped=true&"
import script from "./instagramOverview.vue?vue&type=script&lang=js&"
export * from "./instagramOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9601d9e",
  null
  
)

export default component.exports